import type { GuitarChart } from '../guitarChart.js';
import type { Variant } from '../gameTypes.js';
import { PALETTE_PRISM } from '../builtinPulseMaps/palettes.js';
import { assembleImportedGuitarChart } from './importedGuitarChart.js';
import normalImported from './imported/diamond-normal.guitar.json' with { type: 'json' };
import hardImported from './imported/diamond-hard.guitar.json' with { type: 'json' };
import extremeImported from './imported/diamond-extreme.guitar.json' with { type: 'json' };

export const DIAMOND_GUITAR_VARIANTS: Record<Variant, GuitarChart> = assembleImportedGuitarChart({
  baseSlug: 'diamond',
  baseTitle: "C U Again",
  description: "Cartoon's C U Again on Hirosheap's ranked mania set. Four-diff cut version (109-120s) — the densest stretch lands in our 60s loop window, X tier hits hard.",
  difficulty: 5,
  palette: PALETTE_PRISM,
  audioSrc: '/audio/guitar/diamond.mp3',
  attribution: "\"C U Again\" by Cartoon (feat. Mikk Mae) [NCS Release] - https://ncs.io/CUAgain",
  imported: {
    normal: normalImported,
    hard: hardImported,
    extreme: extremeImported,
  },
});
